var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex messagePage" }, [
    _c("div", { staticClass: "remind" }, [
      _c("div", { staticClass: "model df hao" }, [
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "checkResult" },
            on: {
              click: function($event) {
                return _vm.tabModel("checkResult")
              }
            }
          },
          [
            _vm._v("审核结果"),
            _vm.count.checkResult > 0
              ? _c("i", [
                  _vm._v(
                    _vm._s(
                      _vm.count.checkResult > 10 ? "10+" : _vm.count.checkResult
                    )
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "newAnswer" },
            on: {
              click: function($event) {
                return _vm.tabModel("newAnswer")
              }
            }
          },
          [
            _vm._v("新的回答"),
            _vm.count.ask > 0
              ? _c("i", [
                  _vm._v(_vm._s(_vm.count.ask > 10 ? "10+" : _vm.count.ask))
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modelLi flex",
            class: { cur: _vm.chooseModel == "followLike" },
            on: {
              click: function($event) {
                return _vm.tabModel("followLike")
              }
            }
          },
          [
            _vm._v("关注和点赞"),
            _vm.count.nav > 0
              ? _c("i", [
                  _vm._v(_vm._s(_vm.count.nav > 10 ? "10+" : _vm.count.nav))
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "checkResult",
              expression: "chooseModel=='checkResult'"
            }
          ],
          staticClass: "list",
          on: { scroll: _vm.listenScroll_checkResult }
        },
        _vm._l(_vm.checkResultList, function(v, i) {
          return v.question
            ? _c(
                "div",
                {
                  key: i,
                  staticClass: "li",
                  on: {
                    click: function($event) {
                      return _vm.toDetail("checkResult", v.question, v.id)
                    }
                  }
                },
                [
                  v.types == 1
                    ? _c("div", { staticClass: "cap" }, [
                        _vm._v(_vm._s(_vm.returnRetDate(v.createTime))),
                        _c("i", [_vm._v("|")]),
                        _vm._v("问题被通过")
                      ])
                    : v.types == 2
                    ? _c("div", { staticClass: "cap" }, [
                        _vm._v(_vm._s(_vm.returnRetDate(v.createTime))),
                        _c("i", [_vm._v("|")]),
                        _vm._v("问题被驳回"),
                        _c("br"),
                        _vm._v("原因是"),
                        _c(
                          "div",
                          {
                            staticStyle: { display: "inline" },
                            domProps: {
                              innerHTML: _vm._s(v.question.failReason)
                            }
                          },
                          [_vm._v(_vm._s(v.question.failReason))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "item df hao" }, [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title ov-d" }, [
                        _vm._v(_vm._s(v.question && v.question.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool df" }, [
                        _c("div", { staticClass: "flex" }, [
                          _vm._v(
                            _vm._s(
                              _vm.dateTime(v.question && v.question.createTime)
                            ) +
                              " · " +
                              _vm._s(
                                v.question && v.question.answerTotal > 0
                                  ? v.question.answerTotal + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v.question && v.question.attentionTotal > 0
                                  ? v.question.attentionTotal + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    v.types == 2
                      ? _c("div", { staticClass: "state" }, [
                          _vm._v("审核驳回")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    v.types == 1
                      ? _c("div", { staticClass: "state state2" }, [
                          _vm._v("审核通过")
                        ])
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "newAnswer",
              expression: "chooseModel=='newAnswer'"
            }
          ],
          staticClass: "content"
        },
        [
          _c("div", { staticClass: "nav df hao" }, [
            _c(
              "div",
              {
                staticClass: "navLi flex",
                class: { cur: _vm.chooseNav == "proposeAsk" },
                on: {
                  click: function($event) {
                    return _vm.tabNav("proposeAsk")
                  }
                }
              },
              [
                _vm._v("我提出的问题"),
                _vm.count.proposeAsk > 0
                  ? _c("i", [
                      _vm._v(
                        _vm._s(
                          _vm.count.proposeAsk > 10
                            ? "10+"
                            : _vm.count.proposeAsk
                        )
                      )
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "navLi flex",
                class: { cur: _vm.chooseNav == "followAsk" },
                on: {
                  click: function($event) {
                    return _vm.tabNav("followAsk")
                  }
                }
              },
              [
                _vm.count.followAsk > 0
                  ? _c("i", [
                      _vm._v(
                        _vm._s(
                          _vm.count.followAsk > 10 ? "10+" : _vm.count.followAsk
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v("我关注的问题")
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chooseNav == "proposeAsk",
                  expression: "chooseNav=='proposeAsk'"
                }
              ],
              staticClass: "list2",
              on: { scroll: _vm.listenScroll_proposeAsk }
            },
            _vm._l(_vm.proposeAskList, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "li2",
                  on: {
                    click: function($event) {
                      return _vm.toDetail("proposeAsk", v.question, v.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "cap" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(v.answer && v.answer.creatorName) +
                          "（" +
                          _vm._s(v.answer && v.answer.creatorMapperNumber) +
                          "）"
                      )
                    ]),
                    _c("i", [_vm._v("|")]),
                    _vm._v(
                      _vm._s(
                        _vm.returnRetDate(v.answer && v.answer.createTime)
                      ) + " 回答了问题"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      v.question && v.question.top == 1
                        ? _c("i", { staticClass: "top" })
                        : _vm._e(),
                      v.question && v.question.refining == 1
                        ? _c("i", { staticClass: "prize" })
                        : _vm._e(),
                      _vm._v(_vm._s(v.question && v.question.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "txt ov-4d",
                        domProps: {
                          innerHTML: _vm._s(v.answer && v.answer.content)
                        }
                      },
                      [_vm._v(_vm._s(v.answer && v.answer.content))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "end df hao" }, [
                      _c(
                        "div",
                        {
                          staticClass: "like",
                          class: {
                            has: v.question && v.question.approval != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.likeItem(
                                v.question.id,
                                v.question.approval,
                                v.question,
                                1
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(v.question && v.question.approvalTotal))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collect",
                          class: {
                            has: v.question && v.question.collection != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.collectItem(
                                v.question.id,
                                v.question.collection,
                                v.question,
                                1
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(v.question && v.question.collectionTotal)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "user" }, [
                        _vm._v(
                          _vm._s((v.question && v.question.creatorName) || "")
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(
                            _vm.dateTime(v.question && v.question.createTime)
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chooseNav == "followAsk",
                  expression: "chooseNav=='followAsk'"
                }
              ],
              staticClass: "list2",
              on: { scroll: _vm.listenScroll_followAsk }
            },
            _vm._l(_vm.followAskList, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "li2",
                  on: {
                    click: function($event) {
                      return _vm.toDetail("followAsk", v.question, v.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "cap" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(v.answer && v.answer.creatorName) +
                          "（" +
                          _vm._s(v.answer && v.answer.creatorMapperNumber) +
                          "）"
                      )
                    ]),
                    _c("i", [_vm._v("|")]),
                    _vm._v(
                      _vm._s(
                        _vm.returnRetDate(v.answer && v.answer.createTime)
                      ) + " 回答了问题"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      v.question && v.question.top == 1
                        ? _c("i", { staticClass: "top" })
                        : _vm._e(),
                      v.question && v.question.refining == 1
                        ? _c("i", { staticClass: "prize" })
                        : _vm._e(),
                      _vm._v(" " + _vm._s(v.question && v.question.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "txt ov-4d",
                        domProps: {
                          innerHTML: _vm._s(v.answer && v.answer.content)
                        }
                      },
                      [_vm._v(_vm._s(v.answer && v.answer.content))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "end df hao" }, [
                      _c(
                        "div",
                        {
                          staticClass: "like",
                          class: {
                            has: v.question && v.question.approval != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.likeItem(
                                v.question.id,
                                v.question.approval,
                                v.question,
                                2
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(v.question && v.question.approvalTotal))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collect",
                          class: {
                            has: v.question && v.question.collection != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.collectItem(
                                v.question.id,
                                v.question.collection,
                                v.question,
                                2
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(v.question && v.question.collectionTotal)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "user" }, [
                        _vm._v(
                          _vm._s((v.question && v.question.creatorName) || "")
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(
                            _vm.dateTime(v.question && v.question.createTime)
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.chooseModel == "followLike",
              expression: "chooseModel=='followLike'"
            }
          ],
          staticClass: "content"
        },
        [
          _vm.$h5Power == "instructor" || _vm.$h5Power == "teacher"
            ? _c("div", { staticClass: "nav df hao nav2 nav3" }, [
                _c(
                  "div",
                  {
                    staticClass: "navLi flex",
                    class: { cur: _vm.chooseNav2 == "followNav" },
                    on: {
                      click: function($event) {
                        return _vm.tabNav2("followNav")
                      }
                    }
                  },
                  [
                    _vm._v("关注"),
                    _vm.count.followNav > 0
                      ? _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.count.followNav > 10
                                ? "10+"
                                : _vm.count.followNav
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "navLi flex",
                    class: { cur: _vm.chooseNav2 == "collectNav" },
                    on: {
                      click: function($event) {
                        return _vm.tabNav2("collectNav")
                      }
                    }
                  },
                  [
                    _vm._v("收藏"),
                    _vm.count.collectNav > 0
                      ? _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.count.collectNav > 10
                                ? "10+"
                                : _vm.count.collectNav
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "navLi flex",
                    class: { cur: _vm.chooseNav2 == "likeNav" },
                    on: {
                      click: function($event) {
                        return _vm.tabNav2("likeNav")
                      }
                    }
                  },
                  [
                    _vm.count.likeNav > 0
                      ? _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.count.likeNav > 10 ? "10+" : _vm.count.likeNav
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v("点赞")
                  ]
                )
              ])
            : _c("div", { staticClass: "nav df hao nav2" }, [
                _c(
                  "div",
                  {
                    staticClass: "navLi flex",
                    class: { cur: _vm.chooseNav2 == "followNav" },
                    on: {
                      click: function($event) {
                        return _vm.tabNav2("followNav")
                      }
                    }
                  },
                  [
                    _vm._v("关注"),
                    _vm.count.followNav > 0
                      ? _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.count.followNav > 10
                                ? "10+"
                                : _vm.count.followNav
                            )
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "navLi flex",
                    class: { cur: _vm.chooseNav2 == "likeNav" },
                    on: {
                      click: function($event) {
                        return _vm.tabNav2("likeNav")
                      }
                    }
                  },
                  [
                    _vm.count.likeNav > 0
                      ? _c("i", [
                          _vm._v(
                            _vm._s(
                              _vm.count.likeNav > 10 ? "10+" : _vm.count.likeNav
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v("点赞")
                  ]
                )
              ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chooseNav2 == "followNav",
                  expression: "chooseNav2=='followNav'"
                }
              ],
              staticClass: "list3",
              on: { scroll: _vm.listenScroll_followNav }
            },
            _vm._l(_vm.followNavList, function(v, i) {
              return _c("div", { key: i, staticClass: "li3" }, [
                v.types == 5
                  ? _c(
                      "div",
                      {
                        staticClass: "cap",
                        on: {
                          click: function($event) {
                            return _vm.toFollowUser(v.creatorId)
                          }
                        }
                      },
                      [
                        _c("em", [
                          _vm._v(
                            _vm._s(v.creatorName) +
                              "（" +
                              _vm._s(v.creatorMapperNumber) +
                              "）"
                          )
                        ]),
                        _c("i", [_vm._v("|")]),
                        _vm._v(
                          _vm._s(_vm.returnRetDate(v.createTime)) +
                            " 关注了你提出的问题"
                        )
                      ]
                    )
                  : v.types == 7
                  ? _c(
                      "div",
                      {
                        staticClass: "cap",
                        on: {
                          click: function($event) {
                            return _vm.toFollowUser(v.creatorId)
                          }
                        }
                      },
                      [
                        _c("em", [
                          _vm._v(
                            _vm._s(v.creatorName) +
                              "（" +
                              _vm._s(v.creatorMapperNumber) +
                              "）"
                          )
                        ]),
                        _c("i", [_vm._v("|")]),
                        _vm._v(
                          _vm._s(_vm.returnRetDate(v.createTime)) + " 关注了你"
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                v.types == 5
                  ? _c(
                      "div",
                      {
                        staticClass: "item df hao",
                        on: {
                          click: function($event) {
                            return _vm.toDetail("followNav", v.question, v.id)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "lt flex" }, [
                          _c("div", { staticClass: "title ov-d" }, [
                            _vm._v(_vm._s(v.question && v.question.title))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tool df" }, [
                            _c("div", { staticClass: "flex" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dateTime(
                                    v.question && v.question.createTime
                                  )
                                ) +
                                  " · " +
                                  _vm._s(
                                    v.question && v.question.answerTotal > 0
                                      ? v.question.answerTotal + "人回答"
                                      : "暂无回答"
                                  ) +
                                  " · " +
                                  _vm._s(
                                    v.question && v.question.attentionTotal > 0
                                      ? v.question.attentionTotal + "人关注"
                                      : "暂无关注"
                                  )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chooseNav2 == "collectNav",
                  expression: "chooseNav2=='collectNav'"
                }
              ],
              staticClass: "list3",
              on: { scroll: _vm.listenScroll_collectNav }
            },
            _vm._l(_vm.collectNavList, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "li2",
                  on: {
                    click: function($event) {
                      return _vm.toDetail("collectNav", v.question, v.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "cap" }, [
                    _c("em", [
                      _vm._v(
                        _vm._s(v.creatorName) +
                          "（" +
                          _vm._s(v.creatorMapperNumber) +
                          "）"
                      )
                    ]),
                    _c("i", [_vm._v("|")]),
                    _vm._v(
                      _vm._s(_vm.returnRetDate(v.createTime)) +
                        " 收藏了你的回答"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    _c("div", { staticClass: "title" }, [
                      v.question && v.question.top == 1
                        ? _c("i", { staticClass: "top" })
                        : _vm._e(),
                      v.question && v.question.refining == 1
                        ? _c("i", { staticClass: "prize" })
                        : _vm._e(),
                      _vm._v(_vm._s(v.question && v.question.title))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "txt ov-4d",
                        domProps: { innerHTML: _vm._s(v.question.content) }
                      },
                      [_vm._v(_vm._s(v.question.content))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "end df hao" }, [
                      _c(
                        "div",
                        {
                          staticClass: "like",
                          class: {
                            has: v.question && v.question.approval != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.likeItem(
                                v.question.id,
                                v.question.approval,
                                v.question,
                                3
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(v.question && v.question.approvalTotal))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collect",
                          class: {
                            has: v.question && v.question.collection != 0
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.collectItem(
                                v.question.id,
                                v.question.collection,
                                v.question,
                                3
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(v.question && v.question.collectionTotal)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "user" }, [
                        _vm._v(_vm._s(v.question.creatorName || ""))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "date" }, [
                        _vm._v(
                          _vm._s(
                            _vm.dateTime(v.question && v.question.createTime)
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.chooseNav2 == "likeNav",
                  expression: "chooseNav2=='likeNav'"
                }
              ],
              staticClass: "list3",
              on: { scroll: _vm.listenScroll_likeNav }
            },
            _vm._l(_vm.likeNavList, function(v, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "li3",
                  on: {
                    click: function($event) {
                      return _vm.toDetail("likeNav", v.question, v.id)
                    }
                  }
                },
                [
                  v.types == 6
                    ? _c("div", { staticClass: "cap" }, [
                        _c("em", [
                          _vm._v(
                            _vm._s(v.creatorName) +
                              "（" +
                              _vm._s(v.creatorMapperNumber) +
                              "）"
                          )
                        ]),
                        _c("i", [_vm._v("|")]),
                        _vm._v(
                          _vm._s(_vm.returnRetDate(v.createTime)) +
                            " 点赞了你提出的问题"
                        )
                      ])
                    : v.types == 9
                    ? _c("div", { staticClass: "cap" }, [
                        _c("em", [
                          _vm._v(
                            _vm._s(v.creatorName) +
                              "（" +
                              _vm._s(v.creatorMapperNumber) +
                              "）"
                          )
                        ]),
                        _c("i", [_vm._v("|")]),
                        _vm._v(
                          _vm._s(_vm.returnRetDate(v.createTime)) +
                            " 点赞了你的回答"
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "item df hao" }, [
                    _c("div", { staticClass: "lt flex" }, [
                      _c("div", { staticClass: "title ov-d" }, [
                        _vm._v(_vm._s(v.question && v.question.title))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tool df" }, [
                        _c("div", { staticClass: "flex" }, [
                          _vm._v(
                            _vm._s(
                              _vm.dateTime(v.question && v.question.createTime)
                            ) +
                              " · " +
                              _vm._s(
                                v.question && v.question.answerTotal > 0
                                  ? v.question.answerTotal + "人回答"
                                  : "暂无回答"
                              ) +
                              " · " +
                              _vm._s(
                                v.question && v.question.attentionTotal > 0
                                  ? v.question.attentionTotal + "人关注"
                                  : "暂无关注"
                              )
                          )
                        ])
                      ])
                    ])
                  ])
                ]
              )
            }),
            0
          )
        ]
      )
    ]),
    _vm._v(" "),
    _vm.collectBase.has
      ? _c("div", { staticClass: "collectBase" }, [
          _c("div", { staticClass: "collectBase-box" }, [
            _c("div", { staticClass: "collectBase-top" }, [
              _c("div", {
                staticClass: "collectBase-close",
                on: { click: _vm.closeCollectBase }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "已选择" + _vm._s(_vm.collectBase.choose.length) + "个收藏夹"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectBase-add",
                  on: { click: _vm.showCollectAddBase }
                },
                [_vm._v("新建收藏夹")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collectBase-list" },
              _vm._l(_vm.collectBase.list, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "collectBase-li df cf wao",
                    class: { cur: _vm.collectBase.choose.indexOf(i) >= 0 },
                    on: {
                      click: function($event) {
                        return _vm.chooseCollectBase(i)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "collectBase-title" }, [
                      _vm._v(_vm._s(v.name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "collectBase-answer" }, [
                      _vm._v(_vm._s(v.answerTotal) + "个回答")
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collectBase-btn",
                on: { click: _vm.resCollectBase }
              },
              [_vm._v("确认")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.collectAddBase.has
      ? _c("div", { staticClass: "collectAddBase df wao hao" }, [
          _c("div", { staticClass: "collectAddBase-box" }, [
            _c("div", { staticClass: "collectAddBase-input df hao" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.collectAddBase.val,
                    expression: "collectAddBase.val"
                  }
                ],
                staticClass: "flex",
                attrs: { type: "text", puc: "", placeholder: "输入收藏夹标题" },
                domProps: { value: _vm.collectAddBase.val },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.collectAddBase, "val", $event.target.value)
                    },
                    _vm.checkInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("i", [_vm._v(_vm._s(13 - _vm.collectAddBase.val.length))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "collectAddBase-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.resCollectAddBase }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.closeCollectAddBase }
                },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a02070b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a02070b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/message/index/index.vue
// module id = null
// module chunks = 